/* FENNEK Produktgruppen: Filter, Reiter, Sets-Leiste, Aufklappen, Reihen mit Pfeilen, Komplett-Box, Warenkorb-Rückmeldung */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function smooth(fn) { if (document.startViewTransition && !reduce) { document.startViewTransition(fn); } else { fn(); } }
  function euro(cents) { return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
  function cartEl() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }

  function init(root) {
    if (!root || root.dataset.fpReady) return;
    root.dataset.fpReady = '1';

    root.querySelectorAll('.fp-acc, .fp-group--compact').forEach(function (acc) {
      var row = acc.querySelector('[data-fp-row]');
      var nav = acc.classList.contains('fp-group--compact') ? acc.querySelector('.fp-head-wrap > .fp-nav') : acc.querySelector('.fp-nav');
      if (!row || !nav) return;
      var prev = nav.querySelector('[data-fp-scroll="-1"]');
      var next = nav.querySelector('[data-fp-scroll="1"]');
      function update() {
        var max = row.scrollWidth - row.clientWidth;
        nav.hidden = max <= 2;
        if (prev) prev.disabled = row.scrollLeft <= 2;
        if (next) next.disabled = row.scrollLeft >= max - 2;
      }
      [prev, next].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener('click', function () { row.scrollBy({ left: parseInt(btn.getAttribute('data-fp-scroll'), 10) * row.clientWidth * 0.8 }); });
      });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    });

    root.querySelectorAll('[data-fp-sets-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = panel.hidden;
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        window.dispatchEvent(new Event('resize'));
      });
    });

    root.querySelectorAll('[data-fp-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var g = btn.closest('[data-fp-group]');
        var open = !g.classList.contains('is-open');
        g.classList.toggle('is-open', open);
        g.querySelectorAll('[data-fp-more]').forEach(function (b) {
          b.textContent = open ? b.getAttribute('data-open') : b.getAttribute('data-closed');
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        if (!open) g.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        window.dispatchEvent(new Event('resize'));
      });
    });

    root.querySelectorAll('product-form .fp-add-btn').forEach(function (btn) {
      new MutationObserver(function (list) {
        list.forEach(function (m) {
          var was = (m.oldValue || '').indexOf('loading') !== -1;
          if (was && !btn.classList.contains('loading') && btn.getAttribute('aria-disabled') !== 'true') {
            btn.classList.add('is-added');
            setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
          }
        });
      }).observe(btn, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    });

    root.querySelectorAll('[data-fp-bundle]').forEach(function (box) {
      var inputs = box.querySelectorAll('.fp-bundle-input');
      var totalEl = box.querySelector('[data-fp-bundle-total]');
      var countEl = box.querySelector('[data-fp-bundle-count]');
      var btn = box.querySelector('[data-fp-bundle-add]');
      var msg = box.querySelector('[data-fp-bundle-msg]');
      function sum() {
        var t = 0, n = 0;
        inputs.forEach(function (i) { if (i.checked) { t += parseInt(i.getAttribute('data-price'), 10) || 0; n++; } });
        totalEl.textContent = euro(t);
        countEl.textContent = n;
        btn.disabled = n === 0;
      }
      inputs.forEach(function (i) { i.addEventListener('change', sum); });
      sum();
      btn.addEventListener('click', function () {
        var items = [];
        inputs.forEach(function (i) { if (i.checked) items.push({ id: parseInt(i.value, 10), quantity: 1 }); });
        if (!items.length) return;
        var cart = cartEl();
        var body = { items: items };
        if (cart && cart.getSectionsToRender) {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        btn.classList.add('is-loading'); btn.disabled = true; msg.textContent = '';
        var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { msg.textContent = res.description || res.message || 'Das hat leider nicht geklappt.'; return; }
            btn.classList.add('is-added');
            setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
            if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'fp-bundle' }); } catch (e) {} }
            if (cart && cart.renderContents) {
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              try { cart.renderContents(res); } catch (e) { window.location = (window.routes && window.routes.cart_url) || '/cart'; }
            } else {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function () { msg.textContent = 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.'; })
          .finally(function () { btn.classList.remove('is-loading'); sum(); });
      });
    });

    function syncTabs() {
      root.querySelectorAll('[data-fp-tabs]').forEach(function (w) {
        var tabs = Array.prototype.slice.call(w.querySelectorAll('[data-fp-tab]'));
        var active = null, any = false;
        function grp(t) { return root.querySelector('[data-fp-group][data-fp-key="' + t.getAttribute('data-fp-tab') + '"]'); }
        var pref = w.getAttribute('data-fp-pref') || (tabs[0] && tabs[0].getAttribute('data-fp-tab'));
        tabs.forEach(function (t) {
          var g = grp(t);
          var vis = !!g && !g.classList.contains('is-hidden');
          t.hidden = !vis;
          if (vis) any = true;
          if (vis && t.getAttribute('data-fp-tab') === pref) active = t;
        });
        if (!active) tabs.forEach(function (t) { if (!active && !t.hidden) active = t; });
        tabs.forEach(function (t) {
          var on = t === active;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var g = grp(t);
          if (g) g.classList.toggle('is-tab-off', !on);
        });
        w.hidden = !any;
        w.classList.toggle('has-one-tab', tabs.filter(function (t) { return !t.hidden; }).length < 2);
      });
    }
    root.querySelectorAll('[data-fp-tab]').forEach(function (t) {
      t.addEventListener('click', function () {
        t.closest('[data-fp-tabs]').setAttribute('data-fp-pref', t.getAttribute('data-fp-tab'));
        syncTabs();
        window.dispatchEvent(new Event('resize'));
      });
    });
    syncTabs();

    var catBtns = root.querySelectorAll('[data-fp-cat]');
    var fitBtns = root.querySelectorAll('[data-fp-fit]');
    var doors = root.querySelectorAll('[data-fp-door]');
    if (!catBtns.length && !fitBtns.length && !doors.length) return;
    var map = {};
    var mapEl = root.querySelector('[data-fp-map]');
    if (mapEl) { try { map = JSON.parse(mapEl.textContent); } catch (e) {} }
    var status = root.querySelector('[data-fp-status]');
    var reset = root.querySelector('[data-fp-reset]');
    var fitRow = root.querySelector('[data-fp-row-fit]');
    var groups = root.querySelectorAll('[data-fp-group]');
    var state = { cat: 'all', fit: 'all', label: '', catLabel: '' };

    function press(list, value, attr) {
      list.forEach(function (b) {
        var on = b.getAttribute(attr) === value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function itemsOf(g) {
      return Array.prototype.filter.call(g.querySelectorAll('.fp-grid > .fp-item, .fp-row > .fp-mini'), function (it) { return !it.closest('.fp-sets-panel'); });
    }
    function withsOf(g) {
      return (g.getAttribute('data-fp-with') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    }
    function rawCount(g, fit) {
      var items = itemsOf(g);
      if (fit === 'all' || g.getAttribute('data-fp-usefit') !== 'true') return items.length;
      var list = map[fit] || [];
      return items.filter(function (it) { return list.indexOf(it.getAttribute('data-fp-handle')) !== -1; }).length;
    }
    function countFor(g, fit) {
      var n = rawCount(g, fit);
      var withs = withsOf(g);
      if (n && fit !== 'all' && withs.length && g.getAttribute('data-fp-usefit') === 'true') {
        var parentHit = false;
        groups.forEach(function (p) {
          if (p !== g && withs.indexOf(p.getAttribute('data-fp-heading')) !== -1 && rawCount(p, fit) > 0) parentHit = true;
        });
        if (!parentHit) n = 0;
      }
      return n;
    }
    function groupByKey(k) { return root.querySelector('[data-fp-group][data-fp-key="' + k + '"]'); }

    function apply() {
      var catGroup = state.cat === 'all' ? null : groupByKey(state.cat);
      var fitAllowed = !catGroup || catGroup.getAttribute('data-fp-usefit') === 'true';
      if (!fitAllowed && state.fit !== 'all') { state.fit = 'all'; state.label = ''; press(fitBtns, 'all', 'data-fp-fit'); }
      if (catGroup && state.fit !== 'all' && countFor(catGroup, state.fit) === 0) { state.fit = 'all'; state.label = ''; press(fitBtns, 'all', 'data-fp-fit'); }
      if (fitRow) { fitRow.classList.toggle('is-off', !fitAllowed); fitRow.setAttribute('aria-hidden', fitAllowed ? 'false' : 'true'); }
      press(doors, state.cat, 'data-fp-door');
      var list = state.fit === 'all' ? null : (map[state.fit] || []);
      var total = 0;
      var selHeading = catGroup ? (catGroup.getAttribute('data-fp-heading') || '') : '';
      groups.forEach(function (g) {
        var usesFit = g.getAttribute('data-fp-usefit') === 'true';
        var own = state.cat === 'all' || g.getAttribute('data-fp-key') === state.cat;
        var catOk = own || (selHeading && withsOf(g).indexOf(selHeading) !== -1);
        itemsOf(g).forEach(function (it) {
          var show = !(list && usesFit) || list.indexOf(it.getAttribute('data-fp-handle')) !== -1;
          it.classList.toggle('is-hidden', !show);
        });
        var n = countFor(g, state.fit);
        if (state.cat !== 'all' && g.getAttribute('data-fp-key') === state.cat) n = rawCount(g, state.fit);
        var hidden = !catOk || n === 0;
        g.classList.toggle('is-hidden', hidden);
        g.classList.toggle('is-filtered', !!(list && usesFit));
        if (!hidden && own) total += n;
        var c = g.querySelector('[data-fp-count]');
        if (c) c.textContent = rawCount(g, state.fit);
      });
      fitBtns.forEach(function (b) {
        var f = b.getAttribute('data-fp-fit');
        var off = f !== 'all' && !!catGroup && fitAllowed && countFor(catGroup, f) === 0;
        b.disabled = off;
        b.classList.toggle('is-disabled', off);
      });
      catBtns.forEach(function (b) {
        var k = b.getAttribute('data-fp-cat');
        var g = k === 'all' ? null : groupByKey(k);
        var off = !!g && state.fit !== 'all' && g.getAttribute('data-fp-usefit') === 'true' && countFor(g, state.fit) === 0;
        b.disabled = off;
        b.classList.toggle('is-disabled', off);
      });
      syncTabs();
      window.dispatchEvent(new Event('resize'));
      var active = state.cat !== 'all' || state.fit !== 'all';
      if (status) {
        if (!active) { status.textContent = ''; }
        else {
          var parts = [];
          if (state.cat !== 'all') parts.push(state.catLabel);
          if (state.fit !== 'all') parts.push('für ' + state.label);
          status.textContent = total + (total === 1 ? ' Produkt' : ' Produkte') + ': ' + parts.join(' ');
        }
      }
      if (reset) reset.hidden = !active;
    }

    function goTo() {
      var bar = root.querySelector('.fp-toolbar');
      if (bar) bar.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    doors.forEach(function (d) {
      d.addEventListener('click', function () {
        var id = d.getAttribute('data-fp-door');
        state.cat = state.cat === id ? 'all' : id;
        state.catLabel = d.getAttribute('data-fp-label') || '';
        press(catBtns, state.cat, 'data-fp-cat');
        smooth(apply);
        if (state.cat !== 'all') setTimeout(goTo, reduce ? 0 : 260);
      });
    });
    catBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.cat = b.getAttribute('data-fp-cat');
        state.catLabel = b.textContent.trim();
        press(catBtns, state.cat, 'data-fp-cat');
        smooth(apply);
      });
    });
    fitBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.fit = b.getAttribute('data-fp-fit');
        state.label = b.getAttribute('data-fp-label') || '';
        press(fitBtns, state.fit, 'data-fp-fit');
        smooth(apply);
      });
    });
    if (reset) reset.addEventListener('click', function () {
      state = { cat: 'all', fit: 'all', label: '', catLabel: '' };
      press(catBtns, 'all', 'data-fp-cat');
      press(fitBtns, 'all', 'data-fp-fit');
      smooth(apply);
    });
  }
  function initAll() { document.querySelectorAll('.fp-root').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();